import { render, staticRenderFns } from "./ParkingBarriersArchive.vue?vue&type=template&id=02795d28&scoped=true"
import script from "./ParkingBarriersArchive.vue?vue&type=script&lang=js"
export * from "./ParkingBarriersArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02795d28",
  null
  
)

export default component.exports